import { useEffect, useState } from "react";
import { getlocalStorageLogin } from "common/components/apiConfig";

const useAuth = () => {
  const [authenticated, setAuthenticated] = useState(false);

  useEffect(() => {
    try {
      const localStorageData = getlocalStorageLogin();

      setAuthenticated(
        localStorageData ? localStorageData.authenticated : false
      );
    } catch (error) {
      console.error("Error parsing localStorage data:", error);
      // Handle the error appropriately, such as setting authenticated to false
      setAuthenticated(false);
    }
  }, []);

  const login = (cb) => {
    try {
      const localStorageData = getlocalStorageLogin();

      if (
        localStorageData?.authenticated &&
        localStorageData.authToken &&
        localStorageData.authMemberId
      ) {
        setAuthenticated(true);
      } else {
        setAuthenticated(false);
      }
      cb();
    } catch (error) {
      console.error("Error during login:", error);
      // Handle the error appropriately
    }
  };

  const logout = (cb) => {
    document.cookie = "admin=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
    setAuthenticated(false);
    cb();
  };

  const isAuthenticated = () => {
    return authenticated;
  };

  return { login, logout, isAuthenticated };
};

export default useAuth;
